"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltPmfSurvey = void 0;
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'PMF Survey',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'cc912715-460c-4723-8de6-438f27575f86',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/pmf_survey.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'd4ffffda-8393-43b8-83b3-0526d6824e25',
            data: {
                backgroundColor: '#ffffff',
                label: 'Name',
                requiredField: false,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '3de23a08-084e-4666-a450-44cf1776198c',
            data: {
                backgroundColor: '#ffffff',
                label: 'Email Address',
                requiredField: false,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'email',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'abd6676b-88b6-4cc3-bd9e-7ee7170f4893',
            data: {
                backgroundColor: '#ffffff',
                label: 'Phone Number',
                requiredField: false,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'tel',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '4401c4b2-572b-482c-b244-c04263ea665f',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'How disappointed would you be if you could no longer use our service?',
                options: [
                    {
                        label: 'Very disappointed',
                        id: '45f3cf3a-5e65-43de-98a3-d68749ea33cb',
                        value: false,
                    },
                    {
                        label: 'Somewhat disappointed',
                        id: '4eee9e88-c57c-406c-8233-cd513055f5b4',
                        value: false,
                    },
                    {
                        label: 'Not disappointed',
                        id: 'cf3e7744-be4c-4834-a15f-f2df77e9f665',
                        value: false,
                    },
                    {
                        id: 'b612f8ef-db93-4b98-865e-e378e08bce27',
                        label: 'I do not use this service any more',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-checkbox-list',
            version: '1',
            id: '067f6a93-efa3-44b5-ab90-a85e36850899',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Would you like to be contacted in regards to your answer?',
                options: [
                    {
                        label: 'Yes, please contact me',
                        id: '386cad78-a4f8-4d06-b8a7-2703eebc9ab6',
                        value: true,
                    },
                ],
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: '39079102-4331-4839-8647-b7ba073e6833',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#7F32DC',
                borderRadius: 4,
                buttonColor: '#7F32DC',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Submit',
                textAlign: 'center',
                width: 600,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: 'd4ffffda-8393-43b8-83b3-0526d6824e25',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Name',
        },
        {
            id: '3de23a08-084e-4666-a450-44cf1776198c',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Email Address',
        },
        {
            id: 'abd6676b-88b6-4cc3-bd9e-7ee7170f4893',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Phone Number',
        },
        {
            id: '4401c4b2-572b-482c-b244-c04263ea665f',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: 'How disappointed would you be if you could no longer use our service?',
            options: [
                {
                    label: 'Very disappointed',
                    id: '45f3cf3a-5e65-43de-98a3-d68749ea33cb',
                    value: false,
                },
                {
                    label: 'Somewhat disappointed',
                    id: '4eee9e88-c57c-406c-8233-cd513055f5b4',
                    value: false,
                },
                {
                    label: 'Not disappointed',
                    id: 'cf3e7744-be4c-4834-a15f-f2df77e9f665',
                    value: false,
                },
                {
                    id: 'b612f8ef-db93-4b98-865e-e378e08bce27',
                    label: 'I do not use this service any more',
                    value: false,
                },
            ],
        },
        {
            id: '067f6a93-efa3-44b5-ab90-a85e36850899',
            valueType: 'array-of-string',
            inputType: 'form-checkbox-list',
            label: 'Would you like to be contacted in regards to your answer?',
            options: [
                {
                    label: 'Yes, please contact me',
                    id: '386cad78-a4f8-4d06-b8a7-2703eebc9ab6',
                    value: true,
                },
            ],
        },
    ],
};
const prebuiltPmfSurvey = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: 'Name',
                        variableId: 'd4ffffda-8393-43b8-83b3-0526d6824e25',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Email Address',
                        variableId: '3de23a08-084e-4666-a450-44cf1776198c',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Phone Number',
                        variableId: 'abd6676b-88b6-4cc3-bd9e-7ee7170f4893',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'How disappointed would you be if you could no longer use our service?',
                        variableId: '4401c4b2-572b-482c-b244-c04263ea665f',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Very disappointed","checked":"false"},{"id":2,"text":"Somewhat disappointed","checked":"false"},{"id":3,"text":"Not disappointed","checked":"false"},{"id":"f9f83048-4646-4901-aff4-9e22400ef72d","text":"I do not use this service any more","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: 'Would you like to be contacted in regards to your answer?',
                        variableId: '067f6a93-efa3-44b5-ab90-a85e36850899',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Yes, please contact me","checked":"true"}]',
                        type: 'FormCheckboxList',
                    },
                ],
            },
            type: 'start',
            next: null,
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltPmfSurvey = prebuiltPmfSurvey;
//# sourceMappingURL=pmfSurvey.js.map